var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:[_vm.size],attrs:{"id":"credit-card-form"}}),(_vm.error)?_c('span',{staticClass:"error"},[_vm._v(" "+_vm._s(_vm.error))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }